// extracted by mini-css-extract-plugin
export default {"homePageContainer":"home-page_homePageContainer__P8cx-","homePageContent":"home-page_homePageContent__Xs4jZ"};